import moment from 'moment-timezone';

/**
 * Timestamp + 23h 59m 59s. Effectively "the last drawable second of the
 * same calendar day" — used by the timeline chip renderer to fake a
 * chip that extends to the day boundary when the source range has no
 * explicit `toTimestamp`.
 */
export const addHoursToTwentyFour = (timestamp) => {
	return moment(timestamp).add(23, 'hours').add(59, 'minutes').add(59, 'seconds');
};
